import { gql } from '@apollo/client';

export const ALLOWED_STATE_QUERY = gql`
  query allowedState($id: Int!) {
    allowedState(id: $id) {
      id
      documentTypeName
      documentStateId
      documentStateName
      documentColor
      requestComment
      commentIsMandatory
      requestReason
      isActive
      reasons {
        id
        documentTypeAllowedStateId
        reasonId
        reasonCode
        reasonName
      }
    }
  }
`;

export const DOCUMENT_STATE_REASONS_QUERY = gql`
  query documentStateReasonsList {
    documentStateReasonsList {
      id
      name
    }
  }
`;

export const DOCUMENT_STATES_LIST_QUERY = gql`
  query documentStatesList {
    documentStatesList {
      id
      code
      name
    }
  }
`;
